<template>
  <div class="tj-container">
    <canvas class="lz-canvas"></canvas>
    <div class="wrapper">
      <div class="base">
        <div class="left">
          <Character :dataSource="dataSource.base.character" />
          <Attr :dataSource="dataSource.base.attr" />
        </div>
        <div class="right">
          <ExclusiveEquipment :dataSource="dataSource.base.exclusiveEquipment" />
          <TalentSkill :dataSource="dataSource.base.talentSkill" />
        </div>
      </div>
      <div class="detail" :key="currentStyle.key">
        <div class="left">
          <div class="live2d-box">
            <!-- 语音对话 -->
            <template v-if="hasAudioType && isOpenAudioChat">
              <el-tooltip :value="chatTooltip" effect="dark" content="点击与角色语音互动" placement="bottom-end">
                <div class="audio-chat-entry" @click="handleAudioChat"></div>
              </el-tooltip>
            </template>
            <Live2d :dataSource="currentStyle.live2d" />
            <div v-if="isShowLimit" class="limit-box">
              <div class="border left-top"></div>
              <div class="border right-top"></div>
              <div class="border right-bottom"></div>
              <div class="border left-bottom"></div>
              <div class="inner-box">
                <div class="tip">GAMEKEE健康系统提示你，根据相关规定，您需要实名认证后才能继续浏览。</div>
                <div class="btn" @click="handleVerify">{{ loginUid ? "立即实名" : "立即登录" }}</div>
              </div>
            </div>
          </div>
          <Skin :current="currentStyle" :dataSource="dataSource.style" @switch="switchStyle" />
        </div>
        <div class="right">
          <Skill :dataSource="currentStyle.skill" />
          <Introduction :dataSource="currentStyle.introduction" />
          <Voices :dataSource="currentStyle.voices" />
        </div>
      </div>
      <SkinEvalution :dataSource="dataSource.style" />
      <!-- 插入其他内容 -->
      <slot></slot>
      <!-- 分享弹窗 -->
      <ShareView
        ref="shareView"
        :detail="detail"
        :user="detail.user"
        :dataSource="dataSource"
        :currentStyle="currentStyle"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// components
import Character from "./components/character.vue";
import Attr from "./components/attr.vue";
import TalentSkill from "./components/talentSkill.vue";
import ExclusiveEquipment from "./components/exclusiveEquipment.vue";
import Live2d from "./components/live2d.vue";
import Skill from "./components/skill.vue";
import Introduction from "./components/introduction.vue";
import Voices from "./components/voices.vue";
import Skin from "./components/skin.vue";
import SkinEvalution from "./components/skinEvalution.vue";
import ShareView from "./shareView.vue";
// entry
import { entry } from "../entry.js";
// formatData
import { formatData } from "../utils.js";

const whiteList = ["686531", "677608", "157597", "497891"];

const entryMap = JSON.parse(JSON.stringify(entry));
export default {
  name: "DetailZSTJ",
  props: {
    isShowLimit: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      default: () => {
        return {
          content_json: "",
          entry_data_bind: []
        };
      }
    }
  },
  components: {
    Character,
    Attr,
    TalentSkill,
    ExclusiveEquipment,
    Live2d,
    Skill,
    Introduction,
    Voices,
    Skin,
    SkinEvalution,
    ShareView
  },
  data() {
    return {
      chatTooltip: true,
      dataSource: entryMap,
      currentStyle: { key: "style1", ...entryMap.style.style1 }
    };
  },
  computed: {
    ...mapGetters(["gameInfo", "loginUid"]),
    hasAudioType() {
      return this.dataSource.base.character.audioType.value === "S_h4BRNUdf1";
    },
    isOpenAudioChat() {
      return process.env.VUE_APP_MODE !== "prod" || whiteList.includes(this.$store.getters.loginUser.uid + "");
    }
  },
  watch: {
    detail: {
      handler(val) {
        const dataSource = formatData(val.content_json, val.entry_data_bind, entryMap);
        if (dataSource) {
          this.dataSource = dataSource;
          this.currentStyle = { key: "style1", ...this.dataSource.style["style1"] };
        }
      },
      // deep: true,
      immediate: true
    }
  },
  mounted() {
    this.initCanvas();
  },
  activated() {
    this.chatTooltip = true;
  },
  deactivated() {
    this.chatTooltip = false;
  },
  methods: {
    handleVerify() {
      this.$emit("handleVerify");
    },
    switchStyle(key) {
      this.currentStyle = { key, ...this.dataSource.style[key] };
      this.$nextTick(() => {
        if (this.refreshMap) this.refreshMap();
      });
    },
    initCanvas() {
      let canvas = document.querySelector(".lz-canvas");
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      if (canvas.getContext) {
        let context = canvas.getContext("2d");
        let width = canvas.width;
        let height = canvas.height;

        let r = [];
        let s = 30;
        for (let a = 0; a < s; a++) {
          r.push({
            x: Math.random() * width,
            y: Math.random() * height,
            l: Math.random() * 1,
            xs: -4 + Math.random() * 4 + 2,
            ys: Math.random() * 5 + 1,
            h: Math.random() * 40 + 20
          });
        }
        let u = [];
        for (let b = 0; b < s; b++) {
          u[b] = r[b];
        }
        const t = () => {
          for (let c = 0; c < u.length; c++) {
            let d = u[c];
            // d.x += d.xs;
            d.y += d.ys;
            if (d.x > width || d.y > height) {
              d.x = Math.random() * width;
              d.y = -20;
            }
          }
        };
        setInterval(() => {
          context.clearRect(0, 0, width, height);
          for (let c = 0; c < u.length; c++) {
            let d = u[c];
            context.beginPath();
            context.moveTo(d.x, height - d.y);
            context.lineTo(d.x, height - (d.y + d.l * d.ys + d.h));
            var grd = context.createLinearGradient(0, height - d.y, 0, height - (d.y + d.l * d.ys + d.h));
            grd.addColorStop(0, "rgba(255,255,255,0.05)");
            grd.addColorStop(0.4, "rgba(255,255,255,0.1)");
            grd.addColorStop(d.l < 0.3 ? 1 - d.l : d.l < 0.7 ? 1 - d.l + 0.2 : d.l, "rgba(255,255,255,0.5)");
            grd.addColorStop(0.9, "rgba(255,255,255,0.1)");
            grd.addColorStop(1, "rgba(255,255,255,0.05)");
            context.strokeStyle = grd;
            context.lineWidth = Math.random() + 1.5;
            context.lineCap = "round";
            context.stroke();
          }
          t();
        }, 50);
      }
    },
    /**
     * 计算点赞、评论侧边栏的位置，应始终吸附在主题内容右上角
     */
    refreshAsideBarStyle() {
      /** @type {HTMLDivElement} */
      const el = this.$refs.wrapper;
      if (!el) return;
      const { right, top } = el.getBoundingClientRect();
      this.asideBarStyle = {
        left: `${right + 20}px`,
        top: `${top}px`
      };
    },
    handleAudioChat() {
      this.$router.push(`/${this.alias}/audio-chat/${this.$route.params.id}`);
    }
  }
};
</script>

<style lang="less" scoped>
.tj-container {
  width: 100%;
  min-height: 100vh;
  background: #19181f;
  padding: 22px;
  background: url("~@/assets/zs_imgs/page-bg.png");
  background-size: 100% 100%;

  .wrapper {
    position: relative;
    z-index: 1;
    width: 855px;
    margin: 0 auto;
  }
  .lz-canvas {
    position: fixed;
    z-index: 0;
    width: 100vw;
    height: 100vh;
  }
  .base {
    position: relative;
    z-index: 1;
    width: 100%;
    background-size: contain;
    display: flex;
    gap: 34px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    .left {
      flex-shrink: 0;
      width: 420px;
    }
    .right {
      flex: 1;
    }
  }

  .detail {
    position: relative;
    display: flex;
    gap: 34px;
    padding-top: 12px;
    .left {
      flex-shrink: 0;
      width: 420px;
      .live2d-box {
        position: relative;
        height: 792px;
        .limit-box {
          z-index: 1001;
          position: absolute;
          top: 50%;
          left: 50%;
          width: 312px;
          height: 132px;
          transform: translate(-50%, -50%);
          background-color: rgba(255, 255, 255, 0.5);
          .inner-box {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            height: 100%;
            padding: 25px 25px 20px;
            box-sizing: border-box;
            backdrop-filter: blur(4px);
            .tip {
              font-weight: 400;
              font-size: 13px;
              line-height: 20px;
              color: #000000;
            }
            .btn {
              width: 150px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              font-weight: 500;
              font-size: 14px;
              color: #ffffff;
              background-color: #198ff8;
              cursor: pointer;
            }
          }
          .border {
            z-index: 1002;
            position: absolute;
            width: 12px;
            height: 12px;
            box-sizing: border-box;
            &.left-top {
              left: -1px;
              top: -1px;
              border-left: 2px solid #fff;
              border-top: 2px solid #fff;
            }
            &.right-top {
              right: -1px;
              top: -1px;
              border-right: 2px solid #fff;
              border-top: 2px solid #fff;
            }
            &.right-bottom {
              right: -1px;
              bottom: -1px;
              border-right: 2px solid #fff;
              border-bottom: 2px solid #fff;
            }
            &.left-bottom {
              left: -1px;
              bottom: -1px;
              border-left: 2px solid #fff;
              border-bottom: 2px solid #fff;
            }
          }
        }
        .audio-chat-entry {
          position: absolute;
          width: 20px;
          height: 20px;
          background-image: url("~@/assets/zs_imgs/chat-entry-icon.png");
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center;
          right: 100px;
          top: 26px;
          z-index: 1001;
        }
      }
    }
    .right {
      position: relative;
      z-index: 1;
      flex: 1;
      padding-top: 21px;
    }
  }
}
</style>
